// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa3fbc45","453":"e07b6a2d","732":"ad6b93ac","977":"68f0d0d6"}[chunkId] + ".chunk.js";
};